"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageComponentWebsiteRender = exports.ImageComponentEditor = exports.ImageComponentCreator = exports.ImageComponentRender = void 0;
const react_1 = __importDefault(require("react"));
// import { AiOutlineOrderedList } from 'react-icons/ai'
const react_bootstrap_1 = require("react-bootstrap");
const ImagePicker_1 = __importDefault(require("../../dashboard/components/ImagePicker"));
const structure_1 = require("./structure");
function ImageComponentRender(props) {
    const component = props.component;
    const originalDir = props.originalDir;
    const translatedDir = props.translatedDir;
    const popover = (react_1.default.createElement(react_bootstrap_1.Popover, { id: "popover-basic", style: { maxWidth: 1000 } },
        react_1.default.createElement(react_bootstrap_1.Popover.Header, { as: "h3" }, "\u062A\u0631\u062C\u0645\u0629"),
        react_1.default.createElement(react_bootstrap_1.Popover.Body, null,
            react_1.default.createElement("img", { dir: translatedDir, src: component.translated, className: 'maxWidth100' }))));
    return react_1.default.createElement(react_bootstrap_1.Col, { xs: 10, className: 'mx-auto' },
        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { trigger: "click", placement: "bottom", overlay: popover },
            react_1.default.createElement("img", { dir: originalDir, src: component.original, className: 'maxWidth100' })));
}
exports.ImageComponentRender = ImageComponentRender;
function ImageComponentCreator(props) {
    const dispatch = props.dispatch;
    const [original, setoriginal] = react_1.default.useState('');
    const [translated, settranslated] = react_1.default.useState('');
    return react_1.default.createElement("div", { className: 'my-3' },
        react_1.default.createElement("img", { src: original, className: 'maxWidth100' }),
        react_1.default.createElement(react_bootstrap_1.FloatingLabel, { label: "\u0627\u0644\u0635\u0648\u0631\u0629 \u0627\u0644\u0627\u0635\u0644\u064A" },
            react_1.default.createElement(ImagePicker_1.default, { maxSize: 200000, setImage: (base64) => {
                    setoriginal(base64);
                    dispatch((0, structure_1.imageObject)(base64, translated));
                } })),
        react_1.default.createElement("img", { src: translated, className: 'maxWidth100' }),
        react_1.default.createElement(react_bootstrap_1.FloatingLabel, { label: "\u0627\u0644\u0635\u0648\u0631\u0629 \u0627\u0644\u0645\u062A\u0631\u062C\u0645" },
            react_1.default.createElement(ImagePicker_1.default, { maxSize: 100000, setImage: (base64) => {
                    settranslated(base64);
                    dispatch((0, structure_1.imageObject)(original, base64));
                } })));
}
exports.ImageComponentCreator = ImageComponentCreator;
function ImageComponentEditor(props) {
    const component = props.component;
    const dispatch = props.dispatch;
    const [original, setoriginal] = react_1.default.useState(component.original);
    const [translated, settranslated] = react_1.default.useState(component.translated);
    return (react_1.default.createElement("div", { className: 'my-3' },
        react_1.default.createElement("div", null,
            react_1.default.createElement("img", { src: original, className: 'maxWidth100' }),
            react_1.default.createElement(ImagePicker_1.default, { maxSize: 200000, setImage: (base64) => {
                    setoriginal(base64);
                    dispatch((0, structure_1.imageObject)(base64, translated));
                } }),
            react_1.default.createElement("img", { src: translated, className: 'maxWidth100' }),
            react_1.default.createElement(ImagePicker_1.default, { maxSize: 200000, setImage: (base64) => {
                    settranslated(base64);
                    dispatch((0, structure_1.imageObject)(original, base64));
                } }))));
}
exports.ImageComponentEditor = ImageComponentEditor;
function ImageComponentWebsiteRender(props) {
    const component = props.component;
    return react_1.default.createElement(react_bootstrap_1.Col, { xs: 10, className: 'mx-auto maxWidth100' }, component.translated ?
        react_1.default.createElement("img", { src: component.translated, className: 'maxWidth100' })
        :
            react_1.default.createElement("img", { src: component.original, className: 'maxWidth100' }));
}
exports.ImageComponentWebsiteRender = ImageComponentWebsiteRender;
